<router-outlet></router-outlet>

<div class="rodizio-suporte-alerta" *ngIf="notificacaoRodizioSuporte">
  <div>
    <strong>Atendimento de suporte</strong>
    <span>{{notificacaoRodizioSuporte.nomeGrupo || 'Grupo de suporte'}}</span>
  </div>

  <button type="button" class="btn btn-primary btn-sm" (click)="abraGrupoRodizioSuporte()">
    Ir para o grupo
  </button>

  <button type="button" class="btn btn-link btn-sm" (click)="fecheNotificacaoRodizioSuporte()">
    Fechar
  </button>
</div>

<div kendoDialogContainer></div>


<audio id="beep-bot" >   <source src="/assets/audio/beep-bot.mp3" /> </audio>
